<template>
  <v-container>
    <v-row class="text-center my-5">
      <v-col class="mb-5" cols="12">
        <v-card>
          <v-toolbar color="secondary" class="elevation-0">
            <v-toolbar-title>
              {{ plan?.code }} - {{ plan?.name }}
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-row>
              <v-col cols="12" lg="6">
                <v-row>
                  <v-col cols="5" align="start">
                    <v-icon class="mr-3">mdi-identifier</v-icon>
                    <strong>Plan Code</strong>
                  </v-col>
                  <v-col align="start">
                    {{ plan?.code }}
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="5" align="start">
                    <v-icon class="mr-3">mdi-label</v-icon>
                    <strong>Plan Name</strong>
                  </v-col>
                  <v-col align="start">
                    {{ plan?.name }}
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="5" align="start">
                    <v-icon class="mr-3">mdi-autorenew</v-icon>
                    <strong>Renewal Frequency</strong>
                  </v-col>
                  <v-col align="start">
                    {{ plan?.renewal_frequency }}
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="5" align="start">
                    <v-icon class="mr-3">mdi-currency-usd</v-icon>
                    <strong>Price</strong>
                  </v-col>
                  <v-col align="start">
                    {{ plan?.plan_pricing.currency_code }}
                    {{ plan?.plan_pricing.price }}
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="5" align="start">
                    <v-icon class="mr-3">mdi-autorenew</v-icon>
                    <strong>Renewal Frequency</strong>
                  </v-col>
                  <v-col align="start">
                    {{ plan?.renewal_frequency }}
                  </v-col>
                </v-row>
              </v-col>

              <v-col cols="12" lg="6">
                <v-row>
                  <v-col cols="5" align="start">
                    <v-icon class="mr-3">mdi-earth</v-icon>
                    <strong>Available Countries</strong>
                  </v-col>
                  <v-col align="start">
                    <v-row
                      v-for="country in plan?.available_countries"
                      :key="'available-' + country"
                    >
                      <v-col cols="5" align="start">
                        <v-icon class="mr-3">mdi-vector-point</v-icon>
                        <strong>{{ country }}</strong>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="5" align="start">
                    <v-icon class="mr-3">mdi-earth-off</v-icon>
                    <strong>Unavailable Countries</strong>
                  </v-col>
                  <v-col align="start">
                    <v-row
                      v-for="country in plan?.unavailable_countries"
                      :key="'available-' + country"
                    >
                      <v-col cols="5" align="start">
                        <v-icon class="mr-3">mdi-vector-point</v-icon>
                        <strong>{{ country === "*" ? "ALL" : country }}</strong>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12">
        <v-card>
          <v-toolbar color="secondary" class="elevation-0">
            <v-toolbar-title> {{ plan?.code }} - Quotas </v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-row>
              <v-col cols="3" align="start">
                <v-icon class="mx-3">mdi-redo</v-icon>
                <strong>Rollover Limit</strong>
              </v-col>
              <v-col align="start">
                {{ plan?.rollover_months }}
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-data-table
                  :headers="[
                    { text: 'Quota', value: 'code' },
                    { text: 'Allocation', value: 'allocation' },
                    { text: 'Rollover', value: 'rollover' },
                    { text: 'Post Pay', value: 'postPay' },
                  ]"
                  :items="quotas"
                  hide-default-footer
                  disable-pagination
                  dense
                >
                  <template v-slot:[`item.rollover`]="{ item }">
                    <v-icon v-if="item.rollover"> mdi-check </v-icon>
                    <v-icon v-if="!item.rollover"> mdi-close </v-icon>
                  </template>
                  <template v-slot:[`item.postPay`]="{ item }">
                    <v-icon v-if="item.postPay"> mdi-check </v-icon>
                    <v-icon v-if="!item.postPay"> mdi-close </v-icon>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" lg="6">
        <v-card>
          <v-toolbar color="secondary" class="elevation-0">
            <v-toolbar-title> {{ plan?.code }} - Features </v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-data-table
                  :headers="[
                    { text: 'Feature', value: 'feature' },
                    { text: 'Included', value: 'included' },
                  ]"
                  :items="features"
                  hide-default-footer
                  disable-pagination
                  dense
                >
                  <template v-slot:[`item.included`]="{ item }">
                    <v-icon v-if="item.included"> mdi-check </v-icon>
                    <v-icon v-if="!item.included"> mdi-close </v-icon>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col col="12" lg="6">
        <v-card>
          <v-toolbar color="secondary" class="elevation-0">
            <v-toolbar-title> {{ plan?.code }} - Products </v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-data-table
                  :headers="[
                    { text: 'Product', value: 'code' },
                    { text: 'Price', value: 'price' },
                  ]"
                  :items="products"
                  hide-default-footer
                  disable-pagination
                  dense
                >
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data: () => ({}),

  computed: {
    ...mapGetters(["plans"]),
    planCode() {
      return this.$route.params.uid;
    },
    plan() {
      return this.plans?.find((p) => p.code === this.planCode);
    },

    features() {
      if (!this.plan) return;
      return Object.keys(this.plan.features).map((f) => ({
        feature: f,
        included: this.plan.features[f],
      }));
    },

    quotas() {
      return this.plan?.quotas.map((q) => ({
        code: q.code,
        allocation: q.included,
        rollover: q.rollover,
        postPay: q.post_pay,
      }));
    },

    products() {
      const currency_code = this.plan?.plan_pricing.currency_code;
      return this.plan?.product_pricing.map((p) => ({
        code: p.product_code,
        price: `${currency_code} ${p.price} `,
      }));
    },
  },

  beforeMount() {
    if (!this.$route.params.uid) this.$router.push("/");
  },
};
</script>
